import { BLOG_APP_ID } from '@wix/communities-universal/dist/src/constants/appsConfig';
import { ROLE_WRITER } from '@wix/communities-blog-universal/dist/src/permissions-checker-constants';
import { Owner } from '../types';

export const getUserRoleByApp = (
  user: Owner | undefined,
  appDefinitionId: string,
) => user?.appStore?.[appDefinitionId]?.permissions?.role;
export const getUserRole = (user: Owner | undefined) =>
  getUserRoleByApp(user, BLOG_APP_ID);
export const isWriter = (user: Owner | undefined) =>
  getUserRole(user) === ROLE_WRITER;
